import cx from 'classnames';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { Label } from '../../Label';
import cn from './FocusPreview.css.json';
import './FocusPreview.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FocusPreview = props => {
  const localize = useNCTextLocalizer('Settings');
  const opacity = (props.opacity ?? 100) / 100 * (props.disabled ? 0.3 : 1);
  const thickness = props.thickness ?? 1;
  const color = props.color ? props.color : '#000000';
  const borderStyle = {
    border: `${thickness}px var(--focus-preview-bd-style) ${getRGBString(color, opacity)}`
  };
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({
    'spacing-m': dt.tokens['space-base-m'],
    'spacing-xs': dt.tokens['space-base-xs'],
    'bd-style': dt.tokens['style-action-border-focus']
  }, 'focus-preview');
  return /*#__PURE__*/_jsxs("div", {
    style: tokens,
    className: cx(cn.outerBox, props.disabled && cn.disabled),
    children: [/*#__PURE__*/_jsx("div", {
      style: borderStyle,
      className: cn.maskBox,
      children: /*#__PURE__*/_jsx(Label, {
        className: cn.maskLabel,
        disabled: props.disabled,
        children: localize('settings.focusPreview.itemInFocus.label')
      })
    }), /*#__PURE__*/_jsx(Label, {
      disabled: props.disabled,
      children: localize('settings.focusPreview.adjacentItem.label')
    })]
  });
};
const getRGBString = (hex, opacity) => {
  hex = hex.substring(1, hex.length);
  if (hex.length === 3) {
    hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
  }
  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  return `rgba(${red},${green},${blue},${opacity})`;
};
//# sourceMappingURL=FocusPreview.js.map